import Loader from "react-loader-spinner";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { attachFile, bomTypes, deleteAttachment, downloadFile, getAttachmentList, keyIsLetterOrNumber, networkManager_CheckIn, networkManager_CheckOut, setErrorDialog } from "../../store/api/CommonFunctions";
import { addEditBoM, changeBoMStatus, getBoM, getNextNumber, getStatusList } from "../store/api/ProductionAPI";
import { getSystemSettings } from "../../Sale/store/api/Invoice";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { CheckLg, Clipboard2, CloudUploadFill, Command, DashCircle, Download, FileEarmarkPlus, Link45deg, List, PlusLg, Printer, Reply, Toggles, Toggles2, Trash } from "react-bootstrap-icons";
import NewNumberInput from "../../Components/NewNumberInput";
import { useForm } from "react-hook-form";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalCommands from "../../Components/Modals/ModalCommands";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import ModalInvoiceSerials from "../../Sale/Components/ModalInvoiceSerials";
import ModalSelectBoM from "../Components/ModalSelectBoM";
import { getProductsMeanAvgInStorage } from "../../Sale/store/api/GetAllProduct";
import ModalReferDocument from "../../Components/Modals/ModalReferDocument";

const BoM = () => {
    const { id, type, produceOne } = useParams();
    const frmNewRow = useRef();
    const history = useHistory();
    const inputAttach = useRef();
    const checkOut = useRef(true);
    const [pendingCopy, setPendingCopy] = useState(false);
    const [pendingSubmit, setPendingSubmit] = useState(false);
    const dispatch = useDispatch();
    const inputAtcMoreInfo = useRef();
    const [checkedIn, setCheckedIn] = useState(true);
    const [currentRow, setCurrentRow] = useState(null);
    const [attachList, setAttachList] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    const [submitError, setSubmitError] = useState(null);
    const [bom, setBoM] = useState({ Items: [], Code: 0 });
    const [modalBoM, setModalBoM] = useState({ show: false });
    const [statusList, setStatusList] = useState();
    const [popSerials, setPopSerials] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCommand, setPopCommand] = useState({ show: false });
    const [modalReferDoc, setModalReferDoc] = useState({ show: false });
    const { systemSettings, defaultStorages } = useSelector(state => { return { systemSettings: state.SystemSettingsReducer.systemSettings, defaultStorages: state.SystemSettingsReducer.defaultStorages } });
    const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel", "DefaultSourceStorageHardCode"];
    let productGrouppingType = 1;
    let pDefaultSalePrice = "";
    let pDefaultSalePriceLabel = "";
    if (Array.isArray(systemSettings)) {
        productGrouppingType = Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);
        pDefaultSalePrice = systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue ?? "";
        pDefaultSalePriceLabel = systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue ?? "";
    }
    let title = "";
    const typeNumber = Number(type);
    if (typeNumber === bomTypes.BoM) {
        title = "فرمول ساخت";
    }
    else if (typeNumber === bomTypes.ProductionEstimate) {
        title = "برآورد تولید";
    }
    else if (typeNumber === bomTypes.ProductionInvoice) {
        if (Number(produceOne) === 1) {
            title = "فاکتور مونتاژ";
        }
        else {
            title = "فاکتور تولید";
        }
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "انبار", colName: "StorageName", showCondition: () => typeNumber === bomTypes.ProductionInvoice },
        { colTitle: "مارک قطعه", colName: "ProductHolder", showInMobile: true },
        { colTitle: "نوع قطعه", colName: "ProductName", showInMobile: true, colType: "string" },
        { colTitle: "مدل قطعه", colName: "ProductModel", colType: "string" },
        { colTitle: "سریال قطعه", colName: "ProductSerial", showInMobile: false, showCondition: () => typeNumber !== bomTypes.BoM && Number(produceOne) === 1 },
        { colTitle: "تعداد", colName: "ProductCount" },
        { colTitle: "بهای واحد", colName: "UnitPrice", colType: "currency", showCondition: () => typeNumber !== bomTypes.BoM },
        { colTitle: "بهای کل", colName: "TotalPrice", colType: "currency", showCondition: () => typeNumber !== bomTypes.BoM },
        { colTitle: "توضیحات", colName: "Description", colType: "string" }
    ]
    const tableRowButtons = [];
    if (typeNumber === bomTypes.BoM) {
        tableRowButtons.push(
            { title: "حذف ردیف", type: "delete", className: "group-Btn-smalll btn-danger", onclick: removeRow });
    }
    const popAttachments = (
        (<Popover id="popover-attachments" style={{ maxWidth: "550px", minWidth: "530px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Form.Control ref={inputAtcMoreInfo} placeholder="توضیحات(15 کاراکتر)" maxLength={15} />
                    <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={attach}><CloudUploadFill size={23} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "15%" }}>تاریخ پیوست</th>
                            <th style={{ width: "45%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>توضیحات</th>
                            <th style={{ width: "15%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "40%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "25%", direction: "ltr" }}>{atc.MoreInfo}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "BoMAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const popStatusList = (
        <Popover id="popover-StatusList" style={{ maxWidth: "350px", minWidth: "330px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle"><List size={18} />&nbsp;تغییر وضعیت</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    {statusList?.Data ?
                        <select className="form-control" defaultValue={bom.StatusID} onChange={e => setBoM(prev => ({ ...prev, OldStatusID: prev.StatusID, StatusID: e.target.value }))} >
                            {statusList.Data.map((st, i) => <option value={st.ID} key={i}>{st.StatusTitle}</option>)}
                        </select> :
                        <div className="form-control">
                            <Loader width={25} height={25} color="#bb1370" type="BallTriangle" style={{ display: "inline-block" }} />&nbsp;درحال بارگذاری
                        </div>}
                </FormGroup>
                <Button className="group-Btn mt-1" variant="info" onClick={changeStatus} disabled={!statusList?.Data}><Toggles size={18} />&nbsp;تغییر وضعیت</Button>
            </Popover.Content>
        </Popover >)
    function attach() {
        dispatch(attachFile(inputAttach.current, id, "BoMAttachment", () => getAttachmentList(id, "BoMAttachment", setAttachList), inputAtcMoreInfo.current.value));
    }
    function loadAttachList() {
        if (attachList === null) {
            getAttachmentList(id, "BoMAttachment", setAttachList);
        }
    }
    function delAttach(atcID) {
        dispatch(deleteAttachment(atcID, "BoMAttachment", () => getAttachmentList(id, "BoMAttachment", setAttachList)));
    }
    function changeStatus() {
        const onChange = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تغییر وضعیت");
                setBoM(prev => ({ ...prev, StatusID: prev.OldStatusID }));
            }
            else if (res !== "PENDING") {
                const st = statusList.Data.find(s => Number(s.ID) === Number(bom.StatusID));
                bom.StatusTitle = st.StatusTitle;
                setErrorDialog(dispatch, "success", "تغییر وضعیت");
                setBoM({ ...bom });
            }
        }
        changeBoMStatus(bom, onChange);
    }
    function showModalProduct(e) {
        if (Number(id) > 0) {
            return;
        }
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key) || Number(currentRow?.ID) > 0) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setBoM({
                    ...bom,
                    ProductPrice: data.UnitPrice,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    ProductHolder: data.HolderName,
                    ProductID: data.ProductID,
                    SourceStorageID: data.StorageID,
                    SourceStorageName: data.StorageName
                })
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, invoiceType: "Resid" });

    }
    function showModalDetailProduct(e) {

        //کاربر هنگام ویرایش فرم اجازه تغییر قطعه را ندارد
        // کاربر هنگام ثبت/ویرایش فرمهای بعد از فرمول ساخت اجازه تغییر قطعه را ندارد
        if ((Number(currentRow?.ID) > 0) && (typeNumber !== bomTypes.BoM || Number(id) > 0)) {
            return;
        }
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key) || Number(currentRow?.ID) > 0) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setCurrentRow({
                    ProductPrice: data.UnitPrice,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    ProductHolder: data.HolderName,
                    ProductID: data.ProductID
                })
            }
        }
        setPopProduct({ show: true, value: e.key, partFilter: true, setProductData: setData, invoiceType: "purchase" });
        const inputProductSerial = document.getElementById("detailProduct");
        inputProductSerial.focus();

    }
    function showAddDiv() {
        const f = async () => {
            setCurrentRow({ ID: 0 });
        }
        f().then(() => {
            const inputProductName = document.getElementById("detailProduct");
            inputProductName.focus();
        }
        );
    }
    function showModalStorage(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            if (data) {
                setBoM({ ...bom, DestinationStorageID: data.StorageID, DestinationStorageName: data.StorageName });
            }
        }
        setPopStorage({
            show: true,
            setStorageData: onSelectStorage
        })
    }
    function showModalSourceStorage(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            if (data) {
                const onGetMeanAvgs = (res) => {
                    if (res.Data) {
                        const meanAvgs = res.Data;
                        let totalItemsPrice = 0;
                        bom.Items.forEach(i => {
                            i.StorageID = data.StorageID;
                            i.StorageName = data.StorageName;
                            i.UnitPrice = Number(meanAvgs.find(m => Number(m.ProductID) === Number(i.ProductID))?.MeanAvgPrice ?? 0);
                            i.TotalPrice = i.UnitPrice * Number(i.ProductCount);
                            totalItemsPrice += i.TotalPrice;
                        })
                        bom.TotalItemsPrice = totalItemsPrice;
                        bom.TotalPackPrice = bom.TotalItemsPrice + Number(bom.Wage ?? 0) + Number(bom.OverheadPrice ?? 0);
                        setBoM({ ...bom, SourceStorageID: data.StorageID, SourceStorageName: data.StorageName });
                    }
                }
                const pIDs = bom.Items.map(i => i.ProductID);
                getProductsMeanAvgInStorage(pIDs, data.StorageID, onGetMeanAvgs);


            }
        }
        setPopStorage({
            show: true,
            setStorageData: onSelectStorage
        })
    }
    function onValueChanges(e) {
        const name = e.target.name;
        const value = e.target.value === "" ? 0 : Number(e.target.value);
        if (name === "Wage" || name === "OverheadPrice") {
            bom[name] = value;
            bom.TotalPackPrice = (bom.TotalItemsPrice ?? 0) + (bom.Wage ?? 0) + (bom.OverheadPrice ?? 0);
            setBoM({ ...bom });
        }
        else {
            currentRow[name] = value;
            currentRow.TotalPrice = (currentRow.ProductCount ?? 0) * (currentRow.UnitPrice ?? 0);
            setCurrentRow({ ...currentRow });
        }
    }
    function addNewRow(data) {
        if (bom.Items.some(d => d.ProductSerial === data.ProductSerial && Number(d.ProductID) === Number(currentRow.ProductID))) {
            setErrorDialog(dispatch, "امکان ثبت دو کالا با سریال و برند یکسان وجود ندارد", title);
            return;
        }
        if (bom.Items.some(d => Number(d.ProductID) === Number(data.ProductID))) {
            setErrorDialog(bom, "کالای انتخاب شده در این سطر با کالای انتخاب شده برای دمونتاژ برابر است", title);
            return;
        }
        data.ProductCount = Number(data.ProductCount ?? 1);
        data.UnitPrice = Number(data.UnitPrice ?? 0)
        data.TotalPrice = data.UnitPrice * data.ProductCount;
        //Object.assign(currentRow, data);
        let rowIndex = 0;
        if (bom.Items?.length > 0) {
            rowIndex = bom.Items.map(i => Number(i.RowIndex)).reduce((a, b) => Math.max(a, b), 0);
        }
        bom.Items.push({ /*...currentRow*/...data, RowIndex: rowIndex + 1 });
        bom.TotalItemsPrice = bom.Items.filter(b => !b.SignedForDelete).map(b => Number(b.TotalPrice)).reduce((a, b) => a + b, 0);
        bom.TotalPackPrice = (bom.TotalItemsPrice ?? 0) + (bom.Wage ?? 0) + (bom.OverheadPrice ?? 0);
        setBoM({ ...bom })
        setCurrentRow({
            ID: 0
        });
        frmNewRow.current.reset();
        const inputProductName = document.getElementById("detailProduct");
        inputProductName.focus();

    }
    function removeRow(detail) {
        if (currentRow) {
            setCurrentRow();
        }
        if (detail.ID) {
            bom.Items.find(d => Number(d.ID) === Number(detail.ID)).SignedForDelete = true;
        }
        else {
            bom.Items = bom.Items.filter(d => Number(d.RowIndex) !== Number(detail.RowIndex));
        }
        bom.TotalItemsPrice = bom.Items.filter(b => !b.SignedForDelete).map(b => Number(b.TotalPrice)).reduce((a, b) => a + b, 0);
        bom.TotalPackPrice = (bom.TotalItemsPrice ?? 0) + (bom.Wage ?? 0) + (bom.OverheadPrice ?? 0);
        setBoM({ ...bom });
    }
    function cancelRow() {
        setCurrentRow(null);
        setSubmitError({ ...submitError });
    }
    function setCurrentRowForEdit(row) {
        if (currentRow) {
            setErrorDialog(dispatch, "ابتدا ردیف پیشین را ثبت کنید", title);
            return;
        }
        if (row.e) {
            delete row.e;
        }
        setCurrentRow({ ...row, RowIndex: row.DataIndex, EditMode: true });
    }
    function editRow(data) {
        const er = {};
        if (Object.keys(er).length > 0) {
            return;
        }
        let edittingRow = {};
        if (Number(data.ID) > 0) {
            const oldRow = bom.Items.find(d => Number(d.RowIndex) === Number(data.RowIndex) && d.SignedForDelete?.toString() !== "true");
            oldRow.SignedForDelete = true;
            data.ID = 0;
            bom.Items.push(edittingRow);
        }
        else {
            edittingRow = bom.Items.find(d => Number(d.RowIndex) === Number(data.RowIndex) && d.SignedForDelete?.toString() !== "true");
        }
        data.ProductCount = Number(data.ProductCount ?? 1);
        data.UnitPrice = Number(data.UnitPrice ?? 0)
        data.TotalPrice = data.UnitPrice * data.ProductCount;
        data.RowIndex = Number(data.RowIndex);
        Object.assign(edittingRow, data);
        bom.TotalItemsPrice = bom.Items.filter(b => !b.SignedForDelete).map(b => Number(b.TotalPrice)).reduce((a, b) => a + b, 0);
        bom.TotalPackPrice = (bom.TotalItemsPrice ?? 0) + (bom.Wage ?? 0) + (bom.OverheadPrice ?? 0);
        setCurrentRow(null);
    }
    function onSubmit() {
        if (currentRow) {
            setCurrentRow();
        }
        if ((bom.ProductHolder ?? "") === "") {
            setErrorDialog(dispatch, "برند کالای انتخابی باید مشخص باشد", title);
            return;
        }
        if (typeNumber === bomTypes.ProductionInvoice && (bom.DestinationStorageID ?? "") === "") {
            setErrorDialog(dispatch, "انبار مقصد مشخص نشده است", title);
            return;
        }
        if (typeNumber === bomTypes.ProductionInvoice && Number(id) === 0 && (bom.SourceStorageID ?? "") === "") {
            setErrorDialog(dispatch, "انبار مبدا مشخص نشده است", title);
            return;
        }
        if (!(bom.Items?.length > 0)) {
            setErrorDialog(dispatch, "امکان ثبت فرم بدون ردیف وجود ندارد", title);
            return;
        }
        const onAddEdit = (res) => {
            setPendingSubmit(false);
            if (res.Data) {
                setErrorDialog(dispatch, "عملیات با موفقیت انجام شد", title);
                history.replace(`/Production/BoM/${res.Data}/${typeNumber}/${produceOne}`);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, title);
            }
        }
        if (Number(bom.SourceStorageID) > 0) {
            bom.Items.forEach(itm => {
                itm.StorageID = bom.SourceStorageID;
                itm.StorageName = bom.SourceStorageName;
            });
        }
        bom.BillType = typeNumber;
        if (bom.BillType === bomTypes.ProductionInvoice && Number(produceOne) === 1) {
            bom.ProductCount = 1;
        }
        setPendingSubmit(true);
        addEditBoM(bom, onAddEdit)
    }
    function gotoNew() {
        history.push(`/Production/BoM/0/${produceOne}`);
    }
    function showCommand() {
        setPopCommand({
            show: true,
            attachmentType: "BoM",
            attachmentID: id
        })
    }
    function onClose(event) {
        event.preventDefault();
        event.returnValue = "";
        if (Number(id) > 0 && checkOut.current) {

            networkManager_CheckOut({ DocType: "BoM", DocID: id });
        }
        return "";
    }
    function setNetCheckIn(res) {
        if (res.Message || res.Error) {
            checkOut.current = false;
            setCheckedIn(false);
        }
        else {
            checkOut.current = true;
            setCheckedIn(true);
        }
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/${Object.keys(bomTypes)[typeNumber - 1]}/${e.ctrlKey}`,
            state: {
                dataUrl: `api/BoMAPI/GetBoM?id=${id}`,
                method: "get"
            }
        });
    }
    function showModalSelectBoM() {
        if (!bom.ProductID) {
            setErrorDialog(dispatch, "کالایی انتخاب نشده است.", title);
            return;
        }
        const onSelect = (selected) => {
            if (selected?.ID) {
                const onGet = (res) => {
                    if (res.Data) {
                        res.Data.ParentID = res.Data.ID;
                        res.Data.ParentCode = res.Data.Code;
                        res.Data.Code = bom.Code;
                        res.Data.ID = 0;
                        res.Data.ParentBillType = res.Data.BillType;
                        res.Data.BillType = typeNumber;
                        if (bom.SerialInsert) {
                            const items = [];
                            res.Data.Items.forEach(itm => {
                                for (let i = 0; i < itm.ProductCount; i++) {
                                    const rowIndex = items.map(im => im.RowIndex).reduce((a, b) => Math.max(a, b), 0) + 1;
                                    items.push({ ...itm, ProductCount: 1, TotalPrice: itm.UnitPrice, RowIndex: rowIndex });
                                }
                            });
                            res.Data.Items = items;
                        }
                        res.Data.Items.forEach(i => i.ID = 0);
                        setBoM(res.Data);
                    }
                }
                getBoM(selected.ID, onGet);
            }
        }
        const types = [];
        if (typeNumber === bomTypes.ProductionEstimate) {
            types.push(bomTypes.BoM);
        }
        else if (typeNumber === bomTypes.ProductionInvoice) {
            types.push(bomTypes.BoM, bomTypes.ProductionEstimate);
        }
        setModalBoM({
            show: true,
            productID: bom.ProductID,
            types: types,
            onSelect: onSelect
        });
    }
    function loadStatusList() {
        getStatusList(setStatusList);
    }
    function showDocRefer() {
        const onStatusChanged = (statusID, stageName) => {
            // const status = serviceStatusList.find(s => Number(s.ID) === Number(statusID));
            // setServiceInfo({ ...serviceInfo, StatusID: statusID, Status: status.Status, StageName: stageName });
        }
        setModalReferDoc({
            show: true,
            documentHardCode: "Production",
            documentID: id, documentNumber: bom.Code,
            stageID: bom.StageID,
            onStatusChanged: onStatusChanged
        });
    }
    function copyBoM() {
        const copy = { ...bom };
        copy.ID = 0;
        copy.Items.forEach(i => i.ID = 0);
        //فرمول ساخت نیازی به وضعیت ندارد
        // copy.StatusID = statusList.find(s=>s.Code === "draft")?.ID;
        copy.ParentID = 0;
        copy.ProductionRequestID = 0;
        const onCopy = (res) => {
            setPendingCopy(false);
            if (res.Data) {
                setErrorDialog(dispatch, "عملیات با موفقیت انجام شد", title);
                history.push(`/Production/BoM/${res.Data}/${typeNumber}/${produceOne}`);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, title);
            }
        }
        setPendingCopy(true);
        addEditBoM(copy, onCopy)
    }
    useEffect(() => {
        if (submitError) {
            setSubmitError(null);
        }
        setCurrentRow(null);
        setBoM("PENDING");
        if (!(Number(id) > 0)) {

            const onGetNumber = (res) => {
                if (res.Data) {
                    setBoM({ Code: res.Data, Items: [] });
                }
            }
            getNextNumber(typeNumber, onGetNumber);
        }
        else {
            const onGet = (res) => {
                if (res.Data) {
                    window.addEventListener('beforeunload', onClose);
                    dispatch(networkManager_CheckIn({ DocType: "BoM", DocID: id }, setNetCheckIn));
                    setBoM(res.Data);
                }
            }
            getBoM(id, onGet);
        }
        return () => {
            window.removeEventListener('beforeunload', onClose);
            if (Number(id) > 0 && checkOut.current) {
                networkManager_CheckOut({ DocType: "BoM", DocID: id });
            }
        };
    }, [id, type]);
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-تولید";
        dispatch(getSystemSettings(settingNames));
    }, [])
    return (
        <div className="container-fluid mt-1" style={{ textAlign: "right" }}>
            <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType}
                defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} defaultStorages={defaultStorages} />
            <ModalInvoiceSerials popData={popSerials} setPopData={setPopSerials} productGrouppingType={productGrouppingType} />
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            <ModalSelectBoM popData={modalBoM} setPopData={setModalBoM} />
            <ModalReferDocument popData={modalReferDoc} setPopData={setModalReferDoc} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faFileAlt} size="lg" />&nbsp;
                    {title} شماره {bom?.Code ?? "0"}&nbsp; {typeNumber !== bomTypes.BoM && bom?.StatusTitle?.length > 0 ?
                        <label style={{ border: "5px double blue", transform: "rotate(-25deg)", fontSize: "12px", fontStyle: "italic", padding: "3px 2px 2px 3px", boxShadow: "0px 0px 4px blue" }}>{bom.StatusTitle}</label> : null}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    {bom === "PENDING" &&
                        <div style={{ textAlign: "center" }}>
                            <Loader width={30} height={30} type="BallTriangle" color="#bb1370" />
                        </div>
                    }
                    {bom && bom !== "PENDING" &&
                        <Fragment>
                            <Row className="rowBorder" style={{ margin: 0 }}>
                                {Number(id) === 0 && typeNumber === bomTypes.ProductionInvoice && Number(produceOne) === 1 &&
                                    <div className="rowTitle">
                                        <input type="checkbox" className="form-check-input" id="chkSerialInsert" disabled={bom?.Items?.length > 0} onChange={e => bom.SerialInsert = e.target.checked} />&nbsp;
                                        <label htmlFor="chkSerialInsert">ثبت سریالی</label>
                                    </div>
                                }
                                <Col md={3} className="form-group">
                                    <label>محصول نهایی : </label>
                                    <Form.Control onKeyDown={showModalProduct}
                                        value={[bom?.ProductHolder, bom?.ProductName, bom?.ProductModel].filter(p => p?.length > 0).join("-")} />
                                    {!Number(id) > 0 && <Button className="btn-input-tiny" onClick={showModalProduct}><List size={21} /></Button>}
                                </Col>
                                {typeNumber !== bomTypes.BoM &&
                                    <Col md={2} className="form-group">
                                        <label className="ellipsisLabel" title="شماره فرم مرتبط">شماره فرم مرتبط:</label>
                                        <Form.Control onKeyDown={showModalSelectBoM} value={bom.ParentCode ?? ""} readOnly />
                                        {Number(id) === 0 && <Button className="btn-input-tiny" onClick={showModalSelectBoM}><List size={21} /></Button>}
                                    </Col>
                                }
                                {typeNumber === bomTypes.ProductionInvoice &&
                                    <Col md={2} className="form-group">
                                        <label className="ellipsisLabel" title="سریال آغازین محصول">سریال  {Number(produceOne) === 0 ? "آغازین " : ""}محصول:</label>
                                        <Form.Control type={Number(produceOne) === 1 ? "text" : "number"} onChange={e => setBoM({ ...bom, ProductSerial: e.target.value })} value={bom?.ProductSerial} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                    </Col>
                                }
                                {typeNumber === bomTypes.ProductionInvoice && Number(produceOne) === 0 &&
                                    <Fragment>
                                        <Col md={1} className="form-group" title="پیشوند سریال">
                                            <label className="ellipsisLabel">پیشوند سریال:</label>
                                            <Form.Control onChange={e => bom.SerialPrefix = e.target.value} defaultValue={bom?.SerialPrefix ?? ""} />
                                        </Col>
                                        <Col md={1} className="form-group" title="پسوند سریال">
                                            <label className="ellipsisLabel">پسوند سریال:</label>
                                            <Form.Control onChange={e => bom.SerialSuffix = e.target.value} defaultValue={bom?.SerialSuffix ?? ""} />
                                        </Col>
                                        <Col md={1} className="form-group">
                                            <label>تعداد:</label>
                                            <Form.Control type="number" onChange={e => bom.ProductCount = Number(e.target.value)} defaultValue={bom?.ProductCount ?? 1} />
                                        </Col>
                                    </Fragment>
                                }
                                {typeNumber === bomTypes.ProductionInvoice && !(Number(id) > 0) &&
                                    <Col md={2} className="form-group">
                                        <label>انبار مبدا: </label>
                                        <Form.Control value={bom?.SourceStorageName} readOnly={true} />
                                        <Button className="btn-input-tiny" onClick={showModalSourceStorage} style={{ top: 27 }}><List size={23} /></Button>
                                    </Col>
                                }
                                <Col md={2} className="form-group">
                                    <label>توضیحات: </label>
                                    <Form.Control value={bom?.Description} onChange={e => setBoM({ ...bom, Description: e.target.value })} />
                                </Col>
                            </Row>
                            <Row className="mt-1 mb-1" style={{ marginBottom: "2px", margin: 0 }}>
                                {
                                    currentRow &&
                                    <div className="rowBorder mt-1" style={{ paddingTop: "5px" }}>
                                        <form onSubmit={handleSubmit(currentRow.EditMode ? editRow : addNewRow)} readOnly ref={frmNewRow}>
                                            <table className="flexTable">
                                                <thead>
                                                    <tr>
                                                        <th>مارک قطعه</th>
                                                        <th>نوع قطعه</th>
                                                        <th>مدل قطعه</th>
                                                        {typeNumber === bomTypes.ProductionInvoice &&
                                                            <th>سریال قطعه</th>
                                                        }
                                                        <th>تعداد</th>
                                                        {typeNumber !== bomTypes.BoM &&
                                                            <th>بهای واحد</th>
                                                        }
                                                        <th>توضیحات</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input ref={register({ required: true })}
                                                                type="text" className="form-control tableRowInput"
                                                                onKeyDown={showModalDetailProduct} readOnly
                                                                value={currentRow?.ProductHolder ?? ""}
                                                                name="ProductHolder" />
                                                            {errors?.ProductHolder && <small className="errors">برند قطعه الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <input type="hidden" value={currentRow?.RowIndex ?? ""} readOnly name="RowIndex" ref={register({})} />
                                                            <input type="hidden" value={currentRow?.ID ?? ""} readOnly name="ID" ref={register({})} />
                                                            <input type="hidden" value={currentRow?.ProductID ?? ""} readOnly name="ProductID" ref={register({ required: true })} />
                                                            <input type="hidden" value={currentRow?.StorageID ?? ""} readOnly name="StorageID" ref={register({})} />
                                                            <input type="hidden" value={currentRow?.StorageName ?? ""} readOnly name="StorageName" ref={register({})} />
                                                            <input id="detailProduct" ref={register({ required: true })} type="text" className="form-control tableRowInput" onKeyDown={showModalDetailProduct} readOnly
                                                                value={currentRow?.ProductName ?? ""} name="ProductName" />
                                                            {(errors?.ProductName || errors?.ProductID) && <small className="errors">انتخاب قطعه الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <input ref={register({ required: true })} type="text" className="form-control tableRowInput" onKeyDown={showModalDetailProduct} readOnly
                                                                value={currentRow?.ProductModel ?? ""} name="ProductModel" />
                                                        </td>
                                                        {typeNumber === bomTypes.ProductionInvoice &&
                                                            <td>
                                                                <input type="text" className="form-control tableRowInput" name="ProductSerial" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                                            </td>
                                                        }
                                                        <td>
                                                            <NewNumberInput className="tableRowInput" minvalue={1} inputname="ProductCount" reff={register({})}
                                                                value={currentRow?.ProductCount ?? 1} onChange={onValueChanges} step={0.01} readonly={typeNumber !== bomTypes.BoM} />
                                                        </td>
                                                        {typeNumber !== bomTypes.BoM &&
                                                            <td>
                                                                <NewNumberInput className="tableRowInput" minvalue={0} inputname="UnitPrice" reff={register({})} value={currentRow?.UnitPrice ?? 0} onChange={onValueChanges} step={0.01} />
                                                            </td>
                                                        }
                                                        <td>
                                                            <input ref={register({})} type="text" className="form-control tableRowInput" defaultValue={currentRow?.Description ?? ""} name="Description" />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="mt-1">
                                                <Button className="group-Btn" type="submit" variant="success"><CheckLg size={17} /> ثبت ردیف</Button>
                                                <Button className="group-Btn" variant="danger" onClick={cancelRow}><DashCircle size={17} /> انصراف</Button>
                                            </div>
                                        </form>
                                    </div>
                                }
                            </Row>
                            <Row className="mt-1" style={{ margin: 0 }}>
                                {!currentRow && typeNumber === bomTypes.BoM &&
                                    <Button
                                        variant="light"
                                        className="hoverIcon"
                                        style={{ borderBottom: "1px solid white", borderRadius: ".25rem .25rem 0 0", backgroundColor: "#526ebc", color: "white" }}
                                        onClick={showAddDiv}>

                                        <PlusLg size={21} title="ردیف جدید" />
                                    </Button>
                                }
                                <BihamtaTable className="mt-0" columns={tableColes} rowButtons={tableRowButtons} rowClick={setCurrentRowForEdit}
                                    dataList={{ Data: bom.Items ? bom.Items.filter(d => !d.SignedForDelete).sort((c, d) => c.RowIndex - d.RowIndex) : [] }} maxHeight={500} />
                            </Row>
                            {typeNumber !== bomTypes.BoM &&
                                <Row className="rowBorder">
                                    {typeNumber === bomTypes.ProductionInvoice &&
                                        <Col md={2} className="form-group">
                                            <label>انبار مقصد:</label>
                                            <Form.Control value={bom?.DestinationStorageName} readOnly />
                                            {!(Number(id) > 0) && <Button className="btn-input-tiny" onClick={showModalStorage} style={{ top: 27 }}><List size={23} /></Button>}
                                        </Col>
                                    }
                                    {typeNumber !== bomTypes.BoM &&
                                        <Fragment>
                                            {/* <Col md={2} className="form-group">
                                                <label>جمع کل ردیف ها:</label>
                                                <Form.Control value={bom?.TotalItemsPrice?.toLocaleString() ?? 0} />
                                            </Col>
                                            <Col md={2} className="form-group">
                                                <label>هزینه دستمزد:</label>
                                                <NewNumberInput inputname="Wage" value={bom?.Wage ?? 0} onChange={onValueChanges} />
                                            </Col>
                                            <Col md={2} className="form-group">
                                                <label>هزینه سربار:</label>
                                                <NewNumberInput inputname="OverheadPrice" value={bom?.OverheadPrice ?? 0} onChange={onValueChanges} />
                                            </Col> */}
                                            <Col md={2} className="form-group">
                                                <label>بهای محصول: </label>
                                                <NewNumberInput value={bom?.TotalPackPrice ?? 0} />
                                            </Col>
                                        </Fragment>
                                    }
                                </Row>
                            }
                            <div className="mt-2">
                                <Button variant="success" className="group-Btn-large" onClick={onSubmit} disabled={!checkedIn || pendingCopy || pendingSubmit}>
                                    {pendingSubmit ? <Loader type="TailSpin" width={17} height={17} color="white" style={{ display: "inline-block" }} /> : <CheckLg size={17} />}&nbsp;{(Number(id) > 0 ? "ویرایش " : "ثبت ") + "فرم"} {title}</Button>
                                {Number(id) > 0 &&
                                    <Fragment>
                                        <Button className="group-Btn-large" onClick={gotoNew} disabled={pendingCopy || pendingSubmit}><FileEarmarkPlus size={18} />&nbsp; فرم جدید</Button>
                                        {typeNumber === bomTypes.BoM &&
                                            <Button className="group-Btn-large" onClick={copyBoM} disabled={pendingCopy || pendingSubmit} >
                                                {pendingCopy ? <Loader type="TailSpin" width={17} height={17} color="white" style={{ display: "inline-block" }} /> : <Clipboard2 size={18} />}
                                                &nbsp; رونوشت
                                            </Button>
                                        }
                                        <Button className="group-Btn-large" variant="info" onClick={showCommand}><Command size={16} />&nbsp; دستور کار</Button>
                                        <Button className="group-Btn-large" variant="secondary" onClick={print}><Printer size={16} />&nbsp; چاپ فرم</Button>
                                        <OverlayTrigger trigger="click" placement="left" overlay={popAttachments} rootClose>
                                            <Button variant="light" className="group-Btn-large btn-violet" onClick={loadAttachList}><Link45deg size={19} />&nbsp;پیوست ها</Button>
                                        </OverlayTrigger>
                                        {typeNumber !== bomTypes.BoM &&
                                            <OverlayTrigger trigger="click" placement="left" overlay={popStatusList} rootClose>
                                                <Button className="group-Btn-large" onClick={loadStatusList}><Toggles2 size={18} />&nbsp;تغییر وضعیت</Button>
                                            </OverlayTrigger>
                                        }
                                        <Button variant="secondary" className="group-Btn-large" onClick={showDocRefer}><Reply size={18} />&nbsp;ارجاع به کاربر</Button>
                                    </Fragment>
                                }
                            </div>
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}
export default BoM;